import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import API from "../../API";
import { ru } from '../../data/ru';
import { by } from '../../data/by';
import './admin-test.css';

export default function AdminTest() {
    const language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdOne : by.RoleIdOne;
    const api = new API();
    const [tests, setTests] = useState([]);
    const [isStart, setIsStart] = useState(false);
    const [status, setStatus] = useState(true) //true плажка на запуск теста false на демо тесты
    const arrId = [];

    const getAllTests = async () => {
        try {
            const data = await api.getTests();
            setTests(data);
        } catch (error) {
            console.error('Error fetching tests:', error);
        }
    };

    useEffect(() => {
        getAllTests();
    }, []);

    useEffect(() => {
        setIsStart(tests.some(element => element.is_start));
    }, [tests]);


    const handleChange = (e, id) => {
        if (e.target.checked) {
            arrId.push(id);
        } else {
            arrId.splice(arrId.indexOf(id), 1);
        }
    };

    const handleChangeDemo = async (e, id) => {
       await api.testsDemo({test_id:id,is_demo:e.target.checked})
    };

    const handleClickStart = async () => {
        if (arrId.length !== 0) {
            try {
                await api.startsTests(arrId);
                setIsStart(true);
            } catch (error) {
                console.error('Error starting tests:', error);
                toast('Ошибка запуска теста');

            }
        } else {
            toast('Не выбран ни один тест');
        }
    };

    const handleClickEnd = async () => {
        try {
            await api.finishTests();
            setTests([])
            await getAllTests();
            setIsStart(false);
        } catch (error) {
            console.error('Error finishing tests:', error);
                toast('Ошибка на оставки тестов!');
        }
    };
    const handlerStatus=(status)=>{
        setStatus(status)
    }

    function onClickSendCheckedHandler() {
        api.sendCheckSuperExpert().then(data=>console.log(data)).catch(err=>console.log(err))
    }

    const testStart = <>
        {tests && tests.map(item => (
            <div key={item.id}>
                <h1 className="admin-test_list">
                    <input
                        type="checkbox"
                        defaultChecked={item.is_start}
                        onChange={e => handleChange(e, item.id)}
                        disabled={isStart}
                    />
                    {item.name}
                </h1>
            </div>
        ))}
        {isStart ? (
            <button onClick={handleClickEnd} className="admin-test_button">
                {language.buttonEnd}
            </button>
        ) : (
            <button onClick={handleClickStart} className="admin-test_button">
                {language.buttonStart}
            </button>
        )}
        <button className="admin-test_button" onClick={()=>onClickSendCheckedHandler()}>{language.checking}</button>
    </>

    const testDemo = <>
        {tests && tests.map(item => (
            <div key={item.id}>
                <h1 className="admin-test_list">
                    <input
                        type="checkbox"
                        defaultChecked={item.is_demo}
                        onChange={e => handleChangeDemo(e, item.id)}
                    />
                    {item.name}
                </h1>
            </div>
        ))}
    </>

    return (
        <div>
            <button onClick={()=>handlerStatus(true)} className="admin-test_button">{language.start}</button>
            <button onClick={()=>handlerStatus(false)} className="admin-test_button">{language.demo}</button>
            {status ? testStart : testDemo}
        </div>
    );
}
